import type { PresentationTaskRunner } from "@slot/presentation";

/**
 * One cancellable delay on a runner (the chrome runner: real seconds, frozen by the dev pause). A
 * cancelled runner sleep resolves rather than rejects, so a generation token guards the continuation.
 */
export class RunnerTimer {
  private generation = 0;
  private pending = false;

  public constructor(
    private readonly runner: PresentationTaskRunner,
    private readonly scope: string,
  ) {}

  public get isPending(): boolean {
    return this.pending;
  }

  /** Replace any pending delay with this one. */
  public schedule(seconds: number, fn: () => void): void {
    const generation = ++this.generation;
    this.pending = true;
    void this.runner.sleep(seconds, this.scope).then(() => {
      if (generation !== this.generation) return;
      this.pending = false;
      fn();
    });
  }

  public cancel(): void {
    this.generation++;
    this.pending = false;
  }
}
